import {NetworkAPIVersion} from './network.utils';

export default {
  createCheckoutSession: {
    url: 'payment/checkout-session/',
    apiVersion: NetworkAPIVersion.v1_version,
    method: 'post',
  },
};
